(function ($, Drupal) {

  'use strict';

  Drupal.behaviors.fhz = {
    attach: function (context, settings) {

      // Insert your code here.

    }
  };

})(jQuery, Drupal);
